
exports.isBrowser = typeof window !== 'undefined';



/*****************
 ** WEBPACK FOOTER
 ** ./~/jsondiffpatch/src/environment.js
 ** module id = 158
 ** module chunks = 0
 **/